import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import constants from 'Constants';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';


class TranslationStore {

  @setter @toggle @observable on;

  @setter @observable points;
  @setter @observable pointsPerDollar;
  @setter @observable loginBtnText;
  @setter @observable signupBtnText;
  @setter @observable redeemBtnText;
  @setter @observable viewDetailsBtnText;
  @setter @observable viewRedemptionBtnText;
  @setter @observable submitBtnText;
  @setter @observable cancelBtnText;
  @setter @observable closeBtnText;

  @setter @observable back;
  @setter @observable moreDetails;
  @setter @observable searchPlaceholderText;

  @setter @observable navStoreRewards;
  @setter @observable navEarningPoints;
  @setter @observable navActivities;

  @setter @observable redeemConfirmation;
  @setter @observable redeemCodeNote;
  @setter @observable redeemCodeCopied;
  @setter @observable emptyActivitiesTitle;
  @setter @observable emptyActivitiesDesc;
  @setter @observable activitiesPagination;
  @setter @observable pagination; // same as activitiesPagination

  @setter @observable birthdayNote;
  @setter @observable birthdayUpdated;
  @setter @observable editBirthdayBtnText;

  @setter @observable panelLoggedInTitle;
  @setter @observable panelAnonymousTitle;

  static create(data={}) {
    const instance = new TranslationStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "on": false,

      "points": '',
      "pointsPerDollar": '',
      "loginBtnText": '',
      "signupBtnText": '',
      "redeemBtnText": '',
      "viewDetailsBtnText": '',
      "viewRedemptionBtnText": '',
      "submitBtnText": '',
      "cancelBtnText": '',
      "closeBtnText": '',

      "back": '',
      "moreDetails": '',
      "searchPlaceholderText": '',

      "navStoreRewards": '',
      "navEarningPoints": '',
      "navActivities": '',

      "redeemConfirmation": '',
      "redeemCodeNote": '',
      "redeemCodeCopied": '',
      "emptyActivitiesTitle": '',
      "emptyActivitiesDesc": '',
      "activitiesPagination": '',
      "pagination": '',

      "birthdayNote": '',
      "birthdayUpdated": '',
      "editBirthdayBtnText": '',

      "panelLoggedInTitle": '',
      "panelAnonymousTitle": '',
    };
  }

  constructor(defaults=TranslationStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=TranslationStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "on", "accessor": "on"},

      {"field": "points", "accessor": "points"},
      {"field": "pointsPerDollar", "accessor": "points_per_dollar"},
      {"field": "loginBtnText", "accessor": "login_btn_text"},
      {"field": "signupBtnText", "accessor": "signup_btn_text"},
      {"field": "redeemBtnText", "accessor": "redeem_btn_text"},
      {"field": "viewDetailsBtnText", "accessor": "view_details_btn_text"},
      {"field": "viewRedemptionBtnText", "accessor": "view_redemption_btn_text"},
      {"field": "submitBtnText", "accessor": "submit_btn_text"},
      {"field": "cancelBtnText", "accessor": "cancel_btn_text"},
      {"field": "closeBtnText", "accessor": "close_btn_text"},

      {"field": "back", "accessor": "back"},
      {"field": "moreDetails", "accessor": "more_details"},
      {"field": "searchPlaceholderText", "accessor": "search_placeholder_text"},

      {"field": "navStoreRewards", "accessor": "nav_store_rewards"},
      {"field": "navEarningPoints", "accessor": "nav_earning_points"},
      {"field": "navActivities", "accessor": "nav_activities"},

      {"field": "redeemConfirmation", "accessor": "redeem_confirmation"},
      {"field": "redeemCodeNote", "accessor": "redeem_code_note"},
      {"field": "redeemCodeCopied", "accessor": "redeem_code_copied"},
      {"field": "emptyActivitiesTitle", "accessor": "empty_activities_title"},
      {"field": "emptyActivitiesDesc", "accessor": "empty_activities_desc"},
      {"field": "activitiesPagination", "accessor": "activities_pagination"},
      {"field": "pagination", "accessor": "pagination"},

      {"field": "birthdayNote", "accessor": "birthday_note"},
      {"field": "birthdayUpdated", "accessor": "birthday_updated"},
      {"field": "editBirthdayBtnText", "accessor": "edit_birthday_btn_text"},

      {"field": "panelLoggedInTitle", "accessor": "panel_logged_in_title"},
      {"field": "panelAnonymousTitle", "accessor": "panel_anonymous_title"},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @action setFieldValue(field, value) {
    this[field] = value;
  }
}

export default TranslationStore;



